import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { CommonService } from '@services/common.service';
import { Injectable } from '@angular/core';
import { PermissionGroup } from '../models/permission/permission-group';
import { map, catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';


@Injectable()
export class PermissionGroupService {

    constructor(
        private httpClient: HttpClient,
        private commonService: CommonService
    ) { }


    get(): Observable<PermissionGroup[]> {
        return this.httpClient.get(`${environment.API_END_POINT}/permissionGroups/`, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response => {
                    return (<any>response).content;
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );
    }
}